import { db } from '.././firestoreConfig';
import { collection, getDocs, doc, setDoc, getDoc } from "firebase/firestore"

class UserDataService {
    async getAll() {
        const colRef = collection(db, 'users')
        var docs = [];
        const querySnapshot = await getDocs(colRef);
        querySnapshot.forEach((doc) => {
            if(doc.exists){
                console.log(doc.id, " => ", doc.data());
                docs.push( doc.data());
            }
        });
        return docs;
    }
    async getUser(uid){
        const userRef = await doc(db, "users", uid);
        try{
            await getDoc(userRef);
        }catch(error){
          const errorCode = error.code;
          const errorMessage = error.message;
          console.error("Error: ", errorCode, errorMessage);   
        }
    }
    async createUser(user) {
        let uid = user.uid;
        const userRef = await doc(db, "users", uid);
        try{
            await setDoc(userRef, user, { merge: true });
        }catch(error){
          const errorCode = error.code;
          const errorMessage = error.message;
          console.error("Error: ", errorCode, errorMessage);   
        }
    }
    async updateUser(uid, user) {
        const userRef = await doc(db, "users", uid);
        try{
            await setDoc(userRef, user, { merge: true });
        }catch(error){
          const errorCode = error.code;
          const errorMessage = error.message;
          console.error("Error: ", errorCode, errorMessage);   
        }
    }
}

export default new UserDataService();